import React from 'react'
import { useNavigate } from 'react-router-dom'

const Topic0 = () => {

  const navigate = useNavigate()

  return (
    <div className="py-5 flex flex-col gap-5">
      <h2 className="text-xl sm:text-2xl xl:text-3xl font-bold">Afsendelse af en bog</h2>
      <div className="tekst gap-10 flex flex-col">
        <div className="introduction font-medium">
          <p>Når din bog er blevet købt, oprettes et forsendelseslabel, som du skal bruge til at afsende bogen. Køber betaler forsendelsesomkostninger samt vælger forsendelsesfirmaet og leveringsmetode.<br></br>Det eneste, du som sælger skal gøre, er at pakke bogen og sende den afsted.</p>
        </div>
        <div className="content flex flex-col gap-5">
          <div className="intro flex flex-col gap-2">
            <h2 className="font-bold text-lg">Sådan gør du</h2>
            <p>Under <span className="underline text-emerald-600 hover:text-emerald-700 transition-[] cursor-pointer" onClick={() => navigate('/dashboard/minebøger')}>Mine bøger</span> skal du vælge "<span className="font-semibold">Afsend bogen nu</span>" ud for den solgte bog, hvorefter du finder følgende oplysninger om forsendelsen:</p>
          </div>
          <div className="flex flex-col gap-5">
            <div className="label flex flex-col gap-2">
              <h2 className="title font-semibold">Label</h2>
              <ul className="list-disc flex flex-col gap-2 pl-[20px]">
                <li><p>Hvis forsendelsen transporteres af enten DAO eller Bring, vil du få en '<span className="font-semibold">labelless-kode</span>' &mdash; en ni-cifret kode, du blot skriver på din pakke med vandfast tusch &mdash; og så er pakken klar til at blive indleveret i en pakkeshop. <span className="text-xs sm:text-base text-nowrap">Læs mere om <span className="text-blue-500 underline cursor-pointer hover:text-blue-700 transition-[]" onClick={() => window.open("https://shipmondo.com/dk/ordbog/labelless/", '_blank').focus()}>labelless pakkehåndtering</span></span></p></li>
                <li>Alternativt kan du under "<span className="font-semibold">label til print</span>" downloade en traditionel pakkelabel, som printes og sættes på pakken.</li>
              </ul>
            </div>
            <div className="label flex flex-col gap-2">
              <h2 className="title font-semibold">Indleveringssted</h2>
              <p className="pl-[20px]">Uanset hvilken type label du bruger, skal pakken afleveres i en pakkeshop, der samarbejder med det forsendelsesfirma, som køber har valgt. Du kan finde det nærmeste indleveringssted sammen med dine forsendelsesoplysninger under <span className="underline text-emerald-600 hover:text-emerald-700 transition-[] cursor-pointer" onClick={() => navigate('/dashboard/minebøger')}>Mine bøger</span>.</p>
            </div>
          </div>
        </div>
        <div className="important ring-1 shadow-md ring-emerald-500 p-5 flex gap-5 h-full">
          <div className="flex flex-col gap-2">
            <h2 className="font-semibold uppercase">Vigtigt</h2>
            <p>Bogen skal afsendes <span className="font-semibold">senest 5 dage efter salget er sket</span>. Hvis ikke bogen er afsendt inden for denne tidsramme, annulleres købet automatisk, og pengene refunderes til køber. For at undgå dette, anbefaler vi, at du afsender bogen hurtigst muligt.</p>
          </div>
        </div>
        <div className="questions">
          <p>Har du spørgsmål eller brug for yderligere hjælp til at afsende din bog? <span className="text-emerald-600 hover:text-emerald-700 transition-[] cursor-pointer text-nowrap" onClick={() => navigate('/kontakt')}>Kontakt os</span>.</p>
        </div>
      </div>
    </div>
  )
}

export default Topic0